import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store=new Vuex.Store({
	state: {
		logininfo : {
			islogin:false,
			token:"",
			imei:"",
			myinfo:{cardtypeid:0,memguid:"",mobile:"",cardtypename:"",canuseamount:0},
			flag:"",//wxmp
			openid:"",//ocmoB5SIi8pclLnIDQVJac6wBcwM1
			teammemguid:"",
			teammode:false,//团模式
			teaminfo:[],
			location:[],
			version:"",
			cartnum: 0,
			msgnum: 0,
			wxshop:false,
			autologin:false,
			regcode:false,
			addrinfo:"",
			helplist:[],
			companyinfo:{}
		},
	},
	
	mutations:{
		setlocation(state,location){
			state.logininfo.location.latitude=location.latitude;
			state.logininfo.location.longitude=location.longitude;
			state.logininfo.location.gro=location.gro;
			state.logininfo.location.province=location.province;
		},
		setteammemguid(state,teammemguid){
			state.logininfo.teammemguid=teammemguid;
		},
		setopenid(state,openid){
			state.logininfo.openid=openid;
		},
		setwxshop(state,indata){
			state.logininfo.wxshop=indata.wxshop;
			state.logininfo.autologin=indata.autologin;
			state.logininfo.regcode=indata.regcode;
		},
		// setmyinfo(state,info){
		// 	state.logininfo.myinfo=info;
		// 	var wdmem=sessionStorage.getStorageSync("wdmem");
		// 	wdmem.myinfo=info;
		// 	sessionStorage.setStorageSync("wdmem",wdmem);
		// },
		login(state,indata){
			state.logininfo.islogin=true;
			state.logininfo.token=indata.token;
			state.logininfo.imei=indata.imei;
			state.logininfo.myinfo=indata.myinfo;
			state.logininfo.version=indata.version;
		},
		setcartnum(state,cartnum){
			state.logininfo.cartnum=cartnum;
		},
		setmsgnum(state,msgnum){
			state.logininfo.msgnum=msgnum;
		},
		setteaminfo(state,info){
			state.logininfo.teaminfo=info;
		},
		setaddrinfo(state,info){
			state.logininfo.addrinfo=info;
		},
		sethelplist(state,helplist){
			state.logininfo.helplist=helplist;
		},
		setcompanyinfo(state,info){
			state.logininfo.companyinfo=info;
		},
		loginout(state){
			state.logininfo.islogin=false;
			state.logininfo.token="";
			state.logininfo.myinfo=[];
			state.logininfo.cartnum=0;
			localStorage.removeItem("wdmem");
		},
	}
	
})
export default store